
import { DragMixin } from "./DragMixin";
import { Component, Mixins } from "vue-property-decorator";
import { configStore, documentStore, uiStore } from "@/store/store";
import SpacingBar from "./SpacingBar.vue";
import { ElementPositionAndSize } from "@/lib/canvas/helpers";
import { ValidMouseDragInfo } from "@/lib/canvas/drag/drag";
import {
  fullPathToSpacingProp,
  getCurrentValueInPx
} from "@/lib/canvas/spacing-bars";
import { SpacingBarDescription, SpacingBarLocation } from "@/types/elements";
import { generateDocumentStorePropertyChangeSnapshotLabel } from "@/lib/undo/snapshot-labels/document-store-property-change.utils";
import { SnapshotLabelAction } from "@/types/snapshot";
import { doesElementHavePreset } from "@/lib/presets/presets";

@Component({
  components: { SpacingBar }
})
export default class SpacingBars extends Mixins(DragMixin) {
  get bars(): SpacingBarDescription[] {
    return this.activeElementSpacingBars ? this.activeElementSpacingBars : [];
  }

  get activeElementSpacingBars() {
    if (uiStore.activeElement) {
      return doesElementHavePreset(uiStore.activeElement.id)
        ? false
        : configStore.element(uiStore.activeElement.data.type).spacingBars;
    }
    return false;
  }

  originalValue: number | false = false;

  dragCallback(
    _elementPositionAndSize: ElementPositionAndSize,
    mouseDragInfo: ValidMouseDragInfo,
    handle: SpacingBarLocation
  ) {
    const bar = this.bars.filter(b => b.location === handle).pop();

    if (!uiStore.activeElementId || !bar) return;

    let newValue = 0;
    let currentValue = getCurrentValueInPx(
      bar.affectedPropertyPath,
      bar.cssProperty
    );

    if (!currentValue) {
      currentValue = 0;
    }

    if (!this.originalValue) {
      this.originalValue = currentValue;
    }

    switch (handle) {
      case "inside-top":
      case "inside-bottom":
      case "outside-top":
      case "outside-bottom":
        newValue = this.originalValue + mouseDragInfo.totalYChange;
        break;
      case "inside-left":
      case "inside-right":
      case "outside-left":
      case "outside-right":
        newValue = this.originalValue + mouseDragInfo.totalXChange;
        break;
    }

    if (newValue < 0) {
      newValue = 0;
    }

    const fullPathToSpacingProperty = fullPathToSpacingProp(
      bar.affectedPropertyPath,
      uiStore.currentBreakpoint.id
    );

    documentStore.throttledPropertyChanged({
      elementId: uiStore.activeElementId,
      path: fullPathToSpacingProperty,
      value: {
        number: newValue,
        unit: "px",
        style: `${newValue}px`
      },
      meta: {
        snapshotLabel:
          generateDocumentStorePropertyChangeSnapshotLabel.forElementByTreeNodeId(
            uiStore.activeElementId,
            fullPathToSpacingProperty,
            SnapshotLabelAction.CHANGE
          )
      }
    });
  }

  dragEndCallback() {
    this.originalValue = false;
  }
}
